import { Component, OnInit, Input, OnChanges, OnDestroy, ViewChild, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { UsersService } from 'src/app/users/users.service';
import { DeviceService } from '../../device.service';

import moment from 'moment';
import * as _ from 'underscore';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin, Subject, Subscription, switchMap, takeUntil } from 'rxjs';
import { CommonService, TimeSource } from 'src/app/shared/services/common.service';
import { SiteDashboardService } from '../../../site-dashboard.service';
import { AngularCsv } from 'angular-csv-ext/dist/Angular-csv';
import { DecimalPipe } from '@angular/common';
import { mainDeviceConfig } from '../../device-factory/device-config';
import { DeviceFactory } from '../../device-factory/device-factory';
import { IotahDevice } from '../../device-factory/Iotah-device';
import { SitesService } from 'src/app/sites/sites.service';
import { ColumnsConfig, TableConfig, TableData } from 'sct-custom-table/sct-table/projects/sct-table/src/lib/custom-table-interface';
import { DeviceTypeService } from '../../device-type.service';
import { DeviceCommonService } from '../../device-common.service';
import { ActivatedRoute } from '@angular/router';
import { SiteTemperatureUnit } from '../../../site-settings/site-utilization-settings/site-utilization-settings.interface';

@Component({
	selector: 'app-device-performance-analytics',
	templateUrl: './device-performance-analytics.component.html',
	styleUrls: ['./device-performance-analytics.component.css']
})
export class DevicePerformanceAnalyticsComponent implements OnInit, OnChanges, OnDestroy {

	@Input() device: any = {};
	@Input() currentSite: any;
	@Input() enterprisePermissions: any = {};
	@Input() studyInfo: any = {};
	@Input() studyData: any = {};
	@Input() powerStudyReportData: any = {};
	@Input() selectedDaysPowerStudyReport: any;
	@Input() selectedPeriodFormatted: string;
	@Input() selectedPeriodPrint: { period: string } = null;
	@Input() selectedTruckCriteriaPrint: any = null;
	@Output() printDataReady = new EventEmitter<void>();
	@Output() resetFilter = new EventEmitter<string>();
	@Input() onPrint: boolean = false;

	voltageLevels: any ;
	currentUser: any = {};
	dailyDetails: any;
	endVoltageDailyDetails: any;
	chargeEndVoltageDailyDetails: any;
	usageDailyDetails: any;
	truckHoursDailyDetails: any;
	isShippedDevice: boolean = false;
	// Distinct from isShippedDevice above, which only reflects whether a shipping date exists and drives the
	// realtime chart download buttons. This one carries the backend shipped state (connected on or after the
	// shipping date) and gates the performance reports. Stays null until loaded so a shipped device never
	// flashes "no data to show" first.
	isDeviceShipped: boolean | null = null;
	dateRange: any = {};

	isCollapsed: boolean = false;
	idleChartColumnNames: any = [];
	endVoltageChartColumnNames: any = [];
	usageAmpColumnNames: any = [];
	usageKwColumnNames: any = [];
	truckHoursChartColumnNames: any = [];
	tableItems = [];
	idleChartData: any = {};
	resetTrigger: number = 0;
	endVoltageChartData: any = []; 
	chargeEndVoltageChartData: any = []; 
	batteryUtilizationSettings:any;
	tempChartObject: any = { data: [], columnNames: [], config: {} };
	showTempChart: boolean = false;
	socChartObject: any = { data: [], columnNames: [], config: {} };
	showSocChart: boolean = false;
	show20PercentLine: boolean = true;
	show80PercentLine: boolean = true;
	percentValueOf20 = 20;
	percentValueOf80 = 80;
	highTemperatureLimit: number;
	temperatureUnit: number = SiteTemperatureUnit.FAHRENHEIT;

	// VPC SOC chart (parent-controlled)
	vpcStartDate: Date;
	vpcEndDate: Date;
	vpcMaxDate: Date = moment().subtract(1, 'day').toDate();
	vpcInvalidDateRange: boolean = false;
	vpcSOCData: any[] | null = null;
	vpcMaxChargeVoltage: any[] | null = null;
	vpcMinInuseVoltage: any[] | null = null;
	vpcEndInuseVoltage: any[] | null = null;
	waterLevel: any[] | null = null;
	waterLevelValueMappings = { 0: this.translate.instant('g.low'), 1: this.translate.instant('g.high') };
	waterLevelVAxisTicks = [
		{ v: 0, f: this.translate.instant('g.low') },
		{ v: 1, f: this.translate.instant('g.high') },
	];

	vpcMacAddress: string | null = null;

	// VPC chart toggles
	showVpcSocChart: boolean = false;
	showVpcMaxChargeVoltageChart: boolean = false;
	showVpcMinInuseVoltageChart: boolean = false;
	showVpcEndInuseVoltageChart: boolean = false;
	showDailyWaterLevelChart: boolean = false;
	// table variables
	inuseEndVoltageTableData: TableData[] = [];
	chargeEndVoltageTableData: TableData[] = [];
	selectedPeriod: string = 'last_7_days';
	selectedDays: string = 'allDays';

	/** Which time zone each time column is rendered in. See ST-2326. */
	private readonly timeSourceByColumn: Record<string, TimeSource> = {
		time: TimeSource.Utc,
	};

	endVoltageColumnConfig: ColumnsConfig[] = [
		{key: 'eventId', name: this.translate.instant('events.sequence_id'), type: 'string', hasFilter: false},
		{key: 'time', name: this.translate.instant('events.timestamp'), type: 'date', dateFormat: 'MM/DD/YYYY HH:mm:ss', hasFilter: false}
	];

	endVoltageTableConfig: TableConfig = {
		hasExport: false,
		hasPagination: false,
		fitScreen: true,
		draggable: false
	};

	endVoltageAllTableItems: any = [];
	chargeEndVoltageAllTableItems: any = [];

	usageChartDataAmp: any = [];
	usageChartDataWatt: any = [];
	truckHoursChartData: any = [];
	idleTimesOptions:any = {
		hAxis: {textStyle : {fontSize: 12}},
		legend: {position: 'none'}
	};

	endVoltageInuseOptions: any = {};

	endVoltageChargeOptions: any = {};

	truckHoursOptions:any = {
		legend: {position: 'none'}
	};
	usageAmpOptions:any = {
		legend: {position: 'none'},
		explorer: {
			"actions": [
				"dragToZoom",
				"rightClickToReset"
			],
			maxZoomIn: 50.0,
			keepInBounds: true
		},
	};
	usageKwOptions:any = {
		legend: {position: 'none'},
		explorer: {
			"actions": [
				"dragToZoom",
				"rightClickToReset"
			],
			maxZoomIn: 50.0,
			keepInBounds: true
		},
	};
	deviceInstallationDate: any = null;
	idleTimesFromDate: Date;
	idleTimesToDate: Date = new Date(new Date().setDate(new Date().getDate() - 1));
	idleTimesInvalidDateRange: boolean = false;

	endVoltageFromDate: Date;
	endVoltageToDate: Date = new Date(new Date().setDate(new Date().getDate() - 1));

	usageFromDate: Date;
	usageToDate: Date = new Date(new Date().setDate(new Date().getDate() - 1));
	maxDate = new Date();

	truckHoursFromDate: Date;
	truckHoursToDate: Date = new Date(new Date().setDate(new Date().getDate() - 1));

	endVoltageInvalidDateRange: boolean = false;

	usageInvalidDateRange: boolean = false;
	truckHoursInvalidDateRange: boolean = false;
	deviceVPC;
	idleChartReady = false;

	endVoltageChartReady = false;
	chargeEndVoltageChartReady = false;

	usageChartReady = false;
	truckHoursChartReady = false;
	idleDataFilter: string = 'avg';
	allDailyDetails: any;
	tooltips = {
		device_tags: '',
		idle_events_report: '',
		end_voltage_report: '',
		charge_end_voltage_report: '',
		total_truck_usage: '',
		daily_truck_hours: ''
	};

	permissionsSub: Subscription = new Subscription();
	chartsReady: any = {
		idle_chart_avg: false,
		idle_chart_total: false
	};

	deviceType: number = DeviceFactory.types.iotah;
	chargerDevicesTypes = [DeviceFactory.types.charglink, DeviceFactory.types.brm];
	truckDeviceType = DeviceFactory.types.iotah;

	battlinkDeviceType = DeviceFactory.types.battlink;

	deviceConfig: mainDeviceConfig | null = (new IotahDevice).config;
	studyStartTime: Date;
	studyEndTime: Date;
	siteId: number;
	siteAlertSettings: any = {}; // not used anymore will removed later ST-770
	private destroy$ = new Subject<void>();
	@ViewChild('endVoltageModal') endVoltageModal;
	@ViewChild('chargeEndVoltageModal') chargeEndVoltageModal;

	// utilization Score
	utilizationScoreData = null;
	utilizationScoreTruckData = null;
	energyUtilizationScore = {};

	// rt chart
	showRtChart: boolean = false;
	rtChartObject: any = {};
	rtChartData: any = [];

	rtFromDate: Date;
	rtToDate: Date = new Date(new Date().setDate(new Date().getDate() - 1));
	rtMaxDate = new Date();
	rtInvalidDateRange: boolean = false;
	DeviceFactory = DeviceFactory;

	visibilityCheckboxes: any = {
		voltage: true,
		current: true,
	};

	rtChartDefaultConfig = {
		LegendPosition: 'top',
		hAxis: {
			title: "Time of Day"
		},
		chartArea: {
			width: '80%',
			height: '70%',
			backgroundColor: {
				stroke: '#000',
				strokeWidth: 2
			}
		},
		explorer: {
			"actions": [
				"dragToZoom",
				"rightClickToReset"
			],
			maxZoomIn: 50.0,
			keepInBounds: true
		},
		widgetHeight: 400,
		dataIsDataTable: true,
	}

	powerUsageChartConfig: any = {};
	isIMDevice: boolean = false;

	batteryRealTimeVoltageOptions: Array<{label: string, value: string}> = [ 
		{ label: this.translate.instant('device_performance.battery_real_time_voltage_per_cell'), value: 'voltage_per_cell'},
		{ label: this.translate.instant('device_performance.battery_real_time_voltage_total'), value: 'total_voltage' },
	];
	selectedBatteryRealTimeVoltageShow: string = 'voltage_per_cell';

	printReportSummeryPeriodInfo = {
		period: '',
		from: 0,
		to: 0,
	};

	siteUtilizationSettings: any = null;

	private readonly inuseVoltages: number[] = this.buildVoltageRange(1.7, 2.25, 0.05);
	private readonly chargeVoltages: number[] = this.buildVoltageRange(2.25, 2.75, 0.1);

	private vpcSOCParams$ = new Subject<{ macAddress: string; studyId: number; from: number; to: number }>();

	get rtPeriodPrintFilters(): { label: string, value: string }[] {
		return [
			{ label: 'perf_analytic.period', value: `${moment(this.rtFromDate).format('MM/DD/YYYY')} - ${moment(this.rtToDate).format('MM/DD/YYYY')}` }
		];
	}

	get voltageAndCurrentPrintFilters(): { label: string, value: string }[] {
		return [
			...this.rtPeriodPrintFilters,
			{ label: 'fleet_reports.battery_voltage', value: this.commonService.getOptionLabel(this.batteryRealTimeVoltageOptions, this.selectedBatteryRealTimeVoltageShow) },
			{ label: 'fleet_reports.show_voltage', value: this.translate.instant(this.visibilityCheckboxes.voltage ? 'g.yes' : 'g.no') },
			{ label: 'fleet_reports.show_current', value: this.translate.instant(this.visibilityCheckboxes.current ? 'g.yes' : 'g.no') }
		];
	}

	get socPrintFilters(): { label: string, value: string }[] {
		return [
			...this.rtPeriodPrintFilters,
			{ label: 'studies.soc_20', value: this.translate.instant(this.show20PercentLine ? 'g.yes' : 'g.no') },
			{ label: 'studies.soc_80', value: this.translate.instant(this.show80PercentLine ? 'g.yes' : 'g.no') }
		];
	}

	constructor(
		public usersService: UsersService,
		public deviceService: DeviceService,
		private siteService: SitesService,
		private translate: TranslateService,
		public commonService: CommonService,
		private userService: UsersService,
		private siteDashboardService: SiteDashboardService,
		private chRef: ChangeDetectorRef,
		public deviceTypeService: DeviceTypeService,
		private route: ActivatedRoute,
		public deviceCommonService: DeviceCommonService,
	) { }

	ngOnInit() {
		this.commonService.applyTimeSourceTooltips(this.endVoltageColumnConfig, this.timeSourceByColumn);

		this.siteId = Number(this.route.parent.snapshot.params.siteId);
		this.siteService.getSiteUtilizationSettings(this.siteId).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
			this.siteUtilizationSettings = res?.[0];
			this.temperatureUnit = res[0].batteries_utilization_settings.temperature_unit ?? SiteTemperatureUnit.FAHRENHEIT;

			if(res[0].batteries_utilization_settings.temperature_unit == SiteTemperatureUnit.CELSIUS)
				this.highTemperatureLimit = this.commonService.fahToCel(res[0].batteries_utilization_settings.high_temperature_limit);
			else
				this.highTemperatureLimit = res[0].batteries_utilization_settings.high_temperature_limit;

			this.drawTempChart();
			this.chRef.markForCheck();
		});
		this.voltageLevels = this.currentSite.voltage_levels ? this.currentSite.voltage_levels : this.siteDashboardService.voltageLevels;
		this.permissionsSub = this.siteDashboardService.permissionsOfCurrentSite.subscribe(data=> {
			for(let key in this.tooltips) {
				this.tooltips[key] = this.commonService.getTooltipKey(key, this.userService.userHasNOCAccess(data));
				this.tooltips[key] = this.tooltips[key] ? this.deviceService.getTranslationKey(this.tooltips[key], this.device.config_info) : this.tooltips[key];
			}
			this.chRef.markForCheck();
		});
		this.currentUser = this.usersService.getCurrentUser();
		this.idleChartColumnNames = [this.translate.instant('g.type'), this.translate.instant('perf_analytic.period_mins'), {type: 'string', role: 'style'}];
		this.idleTimesOptions.vAxis = {title: this.translate.instant('g.minutes')};

		this.endVoltageChartColumnNames = [this.translate.instant('rt.sequence_id'), this.translate.instant('g.cycles'), {type: 'string', role: 'style'}];

		this.endVoltageInuseOptions = {
			legend: { position: 'none' },
			hAxis: {
				title: this.translate.instant('event.vpc'),
				ticks: this.inuseVoltages,
			},
			vAxis: {
				title: this.translate.instant('fleet_reports.in_use_cycles_percent'),
				minValue: 0,
				maxValue: 100
			}
		};

		this.endVoltageChargeOptions = {
			legend: { position: 'none' },
			hAxis: {
				title: this.translate.instant('event.vpc'),
				ticks: this.chargeVoltages,
			},
			vAxis: {
				title: this.translate.instant('fleet_reports.charge_cycles_percent'),
				minValue: 0,
				maxValue: 100
			}
		};
		
		this.usageAmpColumnNames = [this.translate.instant('rt.sequence_id'), this.translate.instant('perf_analytic.total_amp_usage')];
		this.usageKwColumnNames = [this.translate.instant('rt.sequence_id'), this.translate.instant('perf_analytic.total_kw_usage')];
		this.usageAmpOptions.vAxis = {title: this.translate.instant('g.amp')};
		this.usageAmpOptions.hAxis = {title: this.translate.instant('g.time')};

		this.usageKwOptions.vAxis = {title: this.translate.instant('g.kw')};
		this.usageKwOptions.hAxis = {title: this.translate.instant('g.time')};

		this.truckHoursChartColumnNames = [this.translate.instant('g.date'), this.translate.instant('site_performance.time_report_title'), /*{type: 'string', role: 'style'}*/];
		this.truckHoursOptions.vAxis = {title: this.translate.instant('site_performance.time_report_title')};
		this.truckHoursOptions.hAxis = {title: this.translate.instant('g.date')};

		this.updatePowerUsageChartConfig();
		this.getUtilizationScoreData();
		this.vpcSOCParams$.pipe(
			switchMap(params =>
				this.deviceService.getDeviceSOCData(params.macAddress, params.studyId, params.from, params.to, false, true)
			),
			takeUntil(this.destroy$)
		).subscribe((res: any) => {
			this.vpcSOCData = res.socData || [];
			this.vpcMaxChargeVoltage = res.maxChargeVoltage || [];
			this.vpcMinInuseVoltage = res.minInuseVoltage || [];
			this.vpcEndInuseVoltage = res.endInuseVoltage || [];
			this.waterLevel = res.waterLevel || [];
			this.chRef.markForCheck();
		});
		this.getVpcSOCData();
	}

	updatePowerUsageChartConfig() {
		this.powerUsageChartConfig = {
			title: this.translate.instant('perf_analytic.truck_power_usage_charts'),
			ampChartTitle: this.translate.instant('fleet_reports.truck_amp_draw'),
			kwChartTitle: this.translate.instant('fleet_reports.truck_kw_draw'),
		}

		if (this.deviceType == DeviceFactory.types.brm || this.deviceType == DeviceFactory.types.charglink) {
			this.powerUsageChartConfig.title = this.translate.instant('perf_analytic.charger_power_usage_charts');
			this.powerUsageChartConfig.ampChartTitle = this.translate.instant('site_performance.charger_amp_draw');
			this.powerUsageChartConfig.kwChartTitle = this.translate.instant('site_performance.charger_kw_draw');
		}
	}

	getUtilizationScoreData() {
		if (DeviceFactory.isIMDeviceType(this.device.config_info.sct_device_type))
			return;
		this.deviceService.getDeviceUtilizationScoreData(this.device.mac_address,[this.deviceType], {studyId: this.studyInfo.id}).pipe(takeUntil(this.destroy$)).subscribe((res: any) => { 
			this.resetTrigger++;
			this.utilizationScoreData = res.data;
			this.isDeviceShipped = res.is_shipped_device;
			this.chRef.markForCheck();
		}); 
	}

	getTruckUtilizationScoreData() {
		this.deviceService.getDeviceUtilizationScoreDataTruckReport(this.device.mac_address,[this.deviceType], {studyId: this.studyInfo.id}).pipe(takeUntil(this.destroy$)).subscribe((res: any) => { 
			this.utilizationScoreTruckData = res.data;
			this.resetFilter.emit();
			this.chRef.markForCheck();
		}); 
	}

	getRTChartData() {
		let zoneDiff	= new Date().getTimezoneOffset() * -1;
		this.rtFromDate = new Date(new Date(this.rtFromDate).setHours(0, 0, 0, 0));
		this.rtToDate = new Date(new Date(this.rtToDate).setHours(23, 59, 59, 999));

		let fromDate:any = new Date(new Date(this.rtFromDate).getTime() + (zoneDiff * 60 * 1000));
		let toDate:any = new Date(new Date(this.rtToDate).getTime() + (zoneDiff * 60 * 1000));

		fromDate	= moment(fromDate).utc().startOf('day').unix();
		toDate		= moment(toDate).utc().endOf('day').unix();

		const battlinkTypes = [
			DeviceFactory.types.battlink,
			DeviceFactory.types.lithiumBattlink,
			DeviceFactory.types.battlinkII
		];
		this.siteService.getDailyRtData(fromDate, toDate, this.device.mac_address, battlinkTypes, 0, this.studyInfo?.id || 0, {}).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
			this.rtChartData = res.data || {};
			this.drawRTrecordsChart();

			if(this.commonService.isFWSupportField('disable_soc', this.device.config_info.fw_version))
				this.drawSocChart();
			
			if (this.deviceConfig.fields.hasTemperatureSensor)
				this.drawTempChart();

			this.chRef.markForCheck();
		});
	}

	resetVPCChartsValues() {
		this.vpcSOCData = null;
		this.vpcMaxChargeVoltage = null;
		this.vpcMinInuseVoltage = null;
		this.vpcEndInuseVoltage = null;
		this.waterLevel = null;

		// this.showVpcSocChart = false;
		// this.showVpcMaxChargeVoltageChart = false;
		// this.showVpcMinInuseVoltageChart = false;
		// this.showVpcEndInuseVoltageChart = false;
		// this.showDailyWaterLevelChart = false;
	}

	getVpcSOCData() {
		if (!this.vpcMacAddress) {
			this.resetVPCChartsValues();
			this.chRef.markForCheck();
			return;
		}

		// Reset before fetch so child charts unmount and remount with fresh data
		this.resetVPCChartsValues();

		let zoneDiff = new Date().getTimezoneOffset() * -1;
		let from: any = new Date(new Date(this.vpcStartDate).setHours(0, 0, 0, 0));
		let to: any = new Date(new Date(this.vpcEndDate).setHours(23, 59, 59, 999));
		from = new Date(from.getTime() + (zoneDiff * 60 * 1000));
		to = new Date(to.getTime() + (zoneDiff * 60 * 1000));

		from = moment(from).utc().startOf('day').unix();
		to = moment(to).utc().endOf('day').unix();

		this.vpcSOCParams$.next({ macAddress: this.vpcMacAddress, studyId: this.studyInfo?.id || 0, from, to });
	}

	vpcDatesChanged() {
		this.vpcInvalidDateRange = false;
		if (moment(this.vpcStartDate).unix() > moment(this.vpcEndDate).unix())
			return this.vpcInvalidDateRange = true;

		this.getVpcSOCData();
	}

	ngOnChanges(changes){
		if(changes.device && this.device && this.device.mac_address) {
			if (this.studyData?.id)
				this.commonService.setPageTabTitle(`${this.translate.instant('studies.power_studies')} - ${this.studyData.name} - ${this.translate.instant('g.performance')}`);
			else if (this.currentSite?.customer_name && this.currentSite?.name)
				this.commonService.setPageTabTitle(`${this.currentSite.customer_name} - ${this.currentSite.name} - ${this.device.serial_number} - ${this.translate.instant('g.performance')}`);
			this.deviceType = changes.device.currentValue.config_info.sct_device_type;
			this.deviceConfig = DeviceFactory.createDevice(this.deviceType).config;
			this.deviceService.formatDeviceFields(this.device.config_info);

			this.isIMDevice = DeviceFactory.isIMDeviceType(this.deviceType);

			this.deviceInstallationDate = null;
			if(this.device.config_info.installation_date > 0)
				this.deviceInstallationDate = new Date(this.device.config_info.installation_date * 1000);

			let fromDateRange = new Date(new Date().setMonth(new Date().getMonth() - 3));
			let formLastMonth = new Date(new Date().setDate(new Date().getDate() - 30));
			if(fromDateRange < this.deviceInstallationDate)
				fromDateRange = this.deviceInstallationDate;

			if(formLastMonth < this.deviceInstallationDate)
				formLastMonth = this.deviceInstallationDate;

			if(this.studyInfo.id && fromDateRange < this.studyStartTime)
				fromDateRange = this.studyStartTime;

			this.idleTimesFromDate = fromDateRange;
			this.endVoltageFromDate = fromDateRange;

			if (this.deviceType == DeviceFactory.types.iotah)
				this.endVoltageFromDate = formLastMonth; // for iotah devices the range is 30 days

			if (this.deviceType == DeviceFactory.types.battlink || this.deviceType == DeviceFactory.types.lithiumBattlink || this.deviceType == DeviceFactory.types.battlinkII) { 
				this.endVoltageFromDate = formLastMonth;
			}

			let last7Days = new Date(new Date().setDate(new Date().getDate() - 7));
			let last30Days = new Date(new Date().setDate(new Date().getDate() - 30));
			if(last7Days < this.deviceInstallationDate)
				last7Days = this.deviceInstallationDate;

			if(last30Days < this.deviceInstallationDate)
				last30Days = this.deviceInstallationDate;

			this.usageFromDate = last30Days;
			this.rtFromDate = last30Days;
			this.truckHoursFromDate = last7Days;

			this.deviceVPC = this.device.config_info.vpc;
			if(this.deviceVPC === undefined) {
				const batteryType = this.deviceService.getBatteryType(this.device.config_info);
				this.deviceVPC = (batteryType == this.deviceService.batteryTypesByName.lithuim_ion) ? 3 : 2;
			}

			if (this.studyEndTime < this.maxDate) {
				this.maxDate = this.studyEndTime;
			}

			if(this.studyInfo?.id)
				this.handleStudyDeviceStartEndDate();

			if(this.deviceConfig.dailyDetails.hasTypes.idleTimes)
				this.getDailyDetails('idleTimes');

			if (this.deviceConfig.dailyDetails.hasTypes.endVoltage || this.deviceConfig.dailyDetails.hasTypes.chargerEndVoltage)
				this.getDailyDetails('endVoltage');

			if (this.deviceConfig.performance.hasUsageReport)
				this.getDailyDetails('usage');

			if (this.deviceConfig.performance.hasTruckHoursReport)
				this.getDailyDetails('truckHours');

			this.device.tags.siteTagsValues = Object.values(this.device.tags.siteTags);

			if (typeof this.device.config_info.shipping_date == 'number') {
				this.device.config_info.shipping_date = this.device.config_info.shipping_date ? moment.unix(this.device.config_info.shipping_date).utc().format('MM/DD/YYYY') : '-';
				this.isShippedDevice = true
			} else {
				this.device.config_info.shipping_date ||= '-';
			}
			this.getUtilizationScoreData();
			this.updatePowerUsageChartConfig();
			if(this.deviceType == DeviceFactory.types.iotah)
				this.getTruckUtilizationScoreData();
			if (DeviceFactory.isBattlinkDeviceType(this.deviceType))
				this.getRTChartData();

			if (!this.studyInfo?.id) {
				this.vpcMacAddress = !this.device.config_info.is_charglink ? (this.device?.config_info?.mac_address || null) : null;
				this.vpcMaxDate = new Date(this.maxDate);
				this.vpcStartDate = moment().subtract(3, 'months').toDate();
				this.vpcEndDate = new Date(this.vpcMaxDate);
				if (this.deviceInstallationDate && moment(this.vpcStartDate).unix() < moment(this.deviceInstallationDate).unix())
					this.vpcStartDate = new Date(this.deviceInstallationDate);
				this.getVpcSOCData();
			}
		}

		if (this.deviceConfig.performance.hasBatteryReport && this.selectedPeriodPrint && changes.selectedPeriodPrint)
			this.getDailyDetails('forPrint');

		if (this.deviceConfig.performance.hasTruckReport && this.selectedPeriodPrint && changes.selectedPeriodPrint)
			this.printDataReady.emit();

		if (changes.studyInfo && this.studyInfo?.id)
			return this.handleStudyDeviceStartEndDate();

		// Handle currentSite changes - update page title when site data becomes available
		if (changes.currentSite && this.device?.serial_number && this.currentSite?.customer_name && this.currentSite?.name) {
			if (this.studyData?.id) {
				this.commonService.setPageTabTitle(`${this.translate.instant('studies.power_studies')} - ${this.studyData.name} - ${this.translate.instant('g.performance')}`);
			} else {
				this.commonService.setPageTabTitle(`${this.currentSite.customer_name} - ${this.currentSite.name} - ${this.device.serial_number} - ${this.translate.instant('g.performance')}`);
			}
		}
	}

	ngOnDestroy() {
		this.permissionsSub.unsubscribe();
		this.destroy$.next();
		this.destroy$.complete();
	}

	getIdleTimesColors(value) {
		if(value < 30)
			return '#109618'; //green
		if(value < 60)
			return '#3366cc'; //blue
		if(value < 120)
			return 'yellow';
		if(value < 240)
			return '#ff9900'; //orange
		return '#dc3912'; //red
	}

	getEndVoltageColors(value) {
		const matchedLevel = this.voltageLevels.find((level) => value >= level.min && value < level.max);
		const color = matchedLevel ? matchedLevel.color : this.voltageLevels[0].color;
		return color;
	}

	canAccessFirstGroup() {
		return this.usersService.hasAccessPermission(this.enterprisePermissions, 'truck_id') ||
				this.usersService.hasAccessPermission(this.enterprisePermissions, 'truck_type') ||
				this.usersService.hasAccessPermission(this.enterprisePermissions, 'truck_sn') ||
				this.usersService.hasAccessPermission(this.enterprisePermissions, 'serial_number');
	}

	canAccessFirstGroupIM() {
		return this.usersService.hasAccessPermission(this.enterprisePermissions, 'serial_number', 'read', null, this.deviceConfig.permissionMapperKey) ||
				this.usersService.hasAccessPermission(this.enterprisePermissions, 'installation_date', 'read', null, this.deviceConfig.permissionMapperKey) ||
				this.usersService.hasAccessPermission(this.enterprisePermissions, 'power_view_sn', 'read', null, this.deviceConfig.permissionMapperKey);
	}

	canAccessSecGroupIM() {
		return this.usersService.hasAccessPermission(this.enterprisePermissions, 'power_view_id', 'read', null, this.deviceConfig.permissionMapperKey) ||
				this.usersService.hasAccessPermission(this.enterprisePermissions, 'load_type', 'read', null, this.deviceConfig.permissionMapperKey);
	}

	idleTimesDatesChanged() {
		this.chartsReady = {
			idle_chart_avg: false,
			idle_chart_total: false
		};
		this.idleTimesInvalidDateRange = false;
		if(moment(this.idleTimesFromDate).unix() > moment(this.idleTimesToDate).unix())
			this.idleTimesInvalidDateRange = true;

		this.getDailyDetails('idleTimes');
	}

	endVoltageDatesChanged() {
		this.endVoltageInvalidDateRange = false;
		if(moment(this.endVoltageFromDate).unix() > moment(this.endVoltageToDate).unix())
			this.endVoltageInvalidDateRange = true;

		this.getDailyDetails('endVoltage');
	}

	usageDatesChanged() {
		this.usageInvalidDateRange = false;
		if(moment(this.usageFromDate).unix() > moment(this.usageToDate).unix())
			this.usageInvalidDateRange = true;

		this.getDailyDetails('usage');
	}

	rtDatesChanged() {
		this.rtInvalidDateRange = false;
		if(moment(this.rtFromDate).startOf('day').unix() > moment(this.rtToDate).startOf('day').unix())
			this.rtInvalidDateRange = true;

		this.getRTChartData();
	}

	truckHoursDatesChanged() {
		this.truckHoursInvalidDateRange = false;
		if(moment(this.truckHoursFromDate).startOf('day').unix() > moment(this.truckHoursToDate).startOf('day').unix())
			this.truckHoursInvalidDateRange = true;
		this.getDailyDetails('truckHours');
	}

	private getDailyDetails(type) {

		this.dailyDetails = [];
		let zoneDiff = new Date().getTimezoneOffset() * -1 * 60 * 1000;
		let fromDate:any, toDate:any;

		switch(type) {
			case 'idleTimes':
				fromDate	= new Date(new Date(this.idleTimesFromDate).getTime() + zoneDiff);
				toDate		= new Date(new Date(this.idleTimesToDate).getTime() + zoneDiff);
				fromDate	= moment(fromDate).utc().startOf('day').unix();
				toDate		= moment(toDate).utc().endOf('day').unix();

				this.deviceService.getDailyDetails(this.device.mac_address, fromDate, toDate, {chart: true}, this.studyInfo?.id || 0).pipe(takeUntil(this.destroy$)).subscribe(data => {
					this.dailyDetails = data;
					this.getIdleChartData();
					this.chRef.markForCheck();
				});
			break;
			case 'endVoltage':
				fromDate	= new Date(new Date(this.endVoltageFromDate).getTime() + zoneDiff);
				toDate		= new Date(new Date(this.endVoltageToDate).getTime() + zoneDiff);
				fromDate	= moment(fromDate).utc().startOf('day').unix();
				toDate		= moment(toDate).utc().endOf('day').unix();

				this.deviceService.getDailyDetails(this.device.mac_address, fromDate, toDate, {}, this.studyInfo?.id || 0).pipe(takeUntil(this.destroy$)).subscribe(data => {
					this.endVoltageDailyDetails = data;
					this.endVoltageChartData = this.getEndVoltageChartData();
					this.chargeEndVoltageDailyDetails = data;
					this.chargeEndVoltageChartData = this.getChargeEndVoltageChartData();
					this.chRef.markForCheck();
				});
			break;
			case 'usage':
				fromDate	= new Date(new Date(this.usageFromDate).getTime() + zoneDiff);
				toDate		= new Date(new Date(this.usageToDate).getTime() + zoneDiff);
				fromDate	= moment(fromDate).utc().startOf('day').unix();
				toDate		= moment(toDate).utc().endOf('day').unix();

				this.usageChartReady = true;
				this.usageChartDataAmp = [];
				this.usageChartDataWatt = [];

				this.siteService.getDailyRtData(fromDate, toDate, this.device.mac_address, [DeviceFactory.types.iotah], 0, this.studyInfo?.id || 0).pipe(takeUntil(this.destroy$)).subscribe(data => {
					if(Object.keys(data).length) {
						this.usageChartReady = true;
						this.usageDailyDetails = data;

						for(const time in data) {
							if(data.hasOwnProperty(time)) {
								this.usageChartDataAmp.push([new Date(data[time].timestamp), data[time].amp]);
								this.usageChartDataWatt.push([new Date(data[time].timestamp), data[time].kw]);
							}
						}
					}
					this.chRef.markForCheck();
				});
			break;
			case 'truckHours':
				fromDate	= new Date(new Date(this.truckHoursFromDate).getTime() + zoneDiff);
				toDate		= new Date(new Date(this.truckHoursToDate).getTime() + zoneDiff);
				fromDate	= moment(fromDate).utc().startOf('day').unix();
				toDate		= moment(toDate).utc().endOf('day').unix();

				this.deviceService.getDailyDetails(this.device.mac_address, fromDate, toDate, {}, this.studyInfo?.id || 0).pipe(takeUntil(this.destroy$)).subscribe(data => {
					this.truckHoursDailyDetails = data;
					this.truckHoursChartData = this.getTruckHoursChartData();
					this.chRef.markForCheck();
				});
			break;
			case 'forPrint':
				const { from, to } = this.commonService.getDateRange(this.selectedPeriodPrint.period, this.device.config_info.installation_date);

				fromDate = new Date(new Date(from).getTime() + zoneDiff);
				toDate = new Date(new Date(to).getTime() + zoneDiff);
				fromDate = moment(fromDate).utc().startOf('day').unix();
				toDate = moment(toDate).utc().endOf('day').unix();

				this.printReportSummeryPeriodInfo.period = this.selectedPeriodPrint.period;
				this.printReportSummeryPeriodInfo.from = fromDate;
				this.printReportSummeryPeriodInfo.to = toDate;

				this.deviceService.getDailyDetails(this.device.mac_address, fromDate, toDate, { forPrint: true, batteryCapacity: this.device.config_info.battery_capacity , period: this.selectedPeriodPrint.period},  this.studyInfo?.id || 0).pipe(takeUntil(this.destroy$)).subscribe(data => {
					this.allDailyDetails = data;
					// Mark dirty before signalling the print trigger: printDataReady starts the
					// countdown to ngxPrint reading the DOM, so the report must be queued to
					// render first.
					this.chRef.markForCheck();
					this.printDataReady.emit();
				});
			break;
		}
	}

	private getIdleChartData() {
		let hours = ['12AM','1AM','2AM','3AM','4AM','5AM','6AM','7AM','8AM','9AM','10AM','11AM','12PM','1PM','2PM','3PM','4PM','5PM','6PM','7PM','8PM','9PM','10PM','11PM'];

		let idleTimes			= [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];

		let totalDays = 0;
		for (let dayIndex in this.dailyDetails) {
			let currentDay = this.dailyDetails[dayIndex];

			if(!Object.keys(currentDay).length)
				continue;

			if(currentDay.non_plugged_in_idle_times) {
				for (let hour = 0; hour < 24; hour++) {
					idleTimes[hour] += currentDay.non_plugged_in_idle_times[hour];
				}
			}
			totalDays++;
		}

		let idle_times = {total: [], avg: []};
		for(let i in idleTimes) {
			let total = +idleTimes[i],
				avg = total / totalDays;
			idle_times.total.push([hours[i], total, 'color: ' + this.getIdleTimesColors(total)]);
			idle_times.avg.push([hours[i], avg, 'color: ' + this.getIdleTimesColors(avg)]);
		}

		this.idleChartReady = true;
		this.idleChartData = idle_times;
	}

	private getEndVoltageChartData() {
		const numberOfCells = this.device.config_info.number_of_cells;
		const rangeStart = 1.7;
		const rangeEnd = 2.25;
		const step = 0.05;

		const voltages: number[] = [];
		const count = Math.round((rangeEnd - rangeStart) / step);
		for (let i = 0; i <= count; i++) {
			const v = rangeStart + i * step;
			voltages.push(+v.toFixed(2));
		}

		const endVoltagesCounts = new Array(voltages.length).fill(0);

		const tableData: any[][] = [];

		for (const day of this.endVoltageDailyDetails) {
			const data = day.end_voltage_events_distribution;
			if (!data) continue;

			for (const endVoltageStr in data) {
				const events = data[endVoltageStr];
				const endVoltage = +endVoltageStr;
				const vpc = +(endVoltage / numberOfCells).toFixed(2);
				const closestIndex = this.findClosestRangeValueIndex(vpc, voltages);
				endVoltagesCounts[closestIndex] += events.length;
				tableData[closestIndex] = tableData[closestIndex] || [];
				for (const event of events) {
					tableData[closestIndex].push({
						sequence_id: event.sequence_id,
						timestamp: moment(event.timestamp * 1000).utc().format('MM/DD/YYYY HH:mm:ss'),
						vpc: vpc
					});
				}
			}
		}
		const totalEvents = endVoltagesCounts.reduce((a, b) => a + b, 0);
		const chartData = voltages.map((v, i) => [
			v,
			numberOfCells > 0 && totalEvents ? +(endVoltagesCounts[i] / totalEvents * 100).toFixed(2) : 0,
			'color: ' + this.getEndVoltageColors(v)
		]);

		this.endVoltageAllTableItems = tableData;
		this.endVoltageChartReady = true;
		return chartData;
	}

	private getChargeEndVoltageChartData() {
		const numberOfCells = this.device.config_info.number_of_cells;
		const rangeStart = 2.25;
		const rangeEnd = 2.75;
		const step = 0.1;

		const voltages: number[] = [];
		const count = Math.round((rangeEnd - rangeStart) / step);
		for (let i = 0; i <= count; i++) {
			const v = rangeStart + i * step;
			voltages.push(+v.toFixed(2));
		}

		const chargeEndVoltagesCounts = new Array(voltages.length).fill(0);
		const tableData: any[][] = [];

		for (const day of this.chargeEndVoltageDailyDetails) {
			const data = day.charge_end_voltage_events_distribution;
			if (!data) continue;

			for (const endVoltageStr in data) {
				const events = data[endVoltageStr];
				const endVoltage = +endVoltageStr;
				const vpc = +(endVoltage / numberOfCells).toFixed(2);
				const closestIndex = this.findClosestRangeValueIndex(vpc, voltages);
				chargeEndVoltagesCounts[closestIndex] += events.length;
				tableData[closestIndex] = tableData[closestIndex] || [];
				for (const event of events) {
					tableData[closestIndex].push({
						sequence_id: event.sequence_id,
						timestamp: moment(event.timestamp * 1000).utc().format('MM/DD/YYYY HH:mm:ss'),
						vpc: vpc
					});
				}
			}
		}
		const totalEvents = chargeEndVoltagesCounts.reduce((a, b) => a + b, 0);

		const chartData = voltages.map((v, i) => [
			v,
			numberOfCells > 0 && totalEvents ? +(chargeEndVoltagesCounts[i] / totalEvents * 100).toFixed(2) : 0,
			'color: ' + this.getEndVoltageColors(v)
		]);

		this.chargeEndVoltageAllTableItems = tableData;
		this.chargeEndVoltageChartReady = true;
		return chartData;
	}

	private buildVoltageRange(start: number, end: number, step: number): number[] {
		const count = Math.round((end - start) / step);
		const result: number[] = new Array(count + 1);
		for (let i = 0; i <= count; i++) {
			result[i] = +((start + i * step).toFixed(2));
		}
		return result;
	}

	private findClosestRangeValueIndex(input: number, range: number[]): number {
		if (input <= range[0]) return 0;
		if (input >= range[range.length - 1]) return range.length - 1;

		for (let i = 1; i < range.length; i++) {
			if (input <= range[i]) return i;
		}

		return range.length - 1;
	}

	private getTruckHoursChartData() {
		let chartData = [];
		const accurateSecondsField = this.deviceConfig.usage.accurateSecondsField;

		for (let dayIndex in this.truckHoursDailyDetails) {
			const accurateSeconds = this.truckHoursDailyDetails[dayIndex][accurateSecondsField];

			chartData.push([
				moment(+this.truckHoursDailyDetails[dayIndex].date*1000).format('l'),
				Math.round((accurateSeconds || 0) / 3600)
			]);
		}
		this.truckHoursChartReady = true;
		return chartData;
	}

	getTimeByIndex(idx, dayTime) {
		let zoneDiff = new Date().getTimezoneOffset() * -1 * 60 * 1000;
		return new Date((((idx * 15 * 60) + dayTime) * 1000) - zoneDiff);
	}

	onSelectEndVoltage(event) {
		this.inuseEndVoltageTableData = [];
		let tableData: TableData[] = [];

		if(!event)
			return;

		let selectedDevicesInfo = this.endVoltageAllTableItems[event.row];
		for(let item of selectedDevicesInfo) {
			tableData.push({
				eventId: {value: item.sequence_id},
				time: {value: item.timestamp},
			})
		}

		this.inuseEndVoltageTableData = tableData;
		this.endVoltageModal.show();
	}

	onSelectChargeEndVoltage(event) {
		this.chargeEndVoltageTableData = [];
		let tableData: TableData[] = [];

		if(!event)
			return;

		let selectedDevicesInfo = this.chargeEndVoltageAllTableItems[event.row];

		for(let item of selectedDevicesInfo) {
			tableData.push({
				eventId: {value: item.sequence_id},
				time: {value: item.timestamp},
			})
		}

		this.chargeEndVoltageTableData = tableData;
		this.chargeEndVoltageModal.show();
	}

	exportIdleEvents() {
		let decimalPipe: DecimalPipe = new DecimalPipe("en-US");

		let alphabits = this.commonService.alphabetCharacters;
		let columnNames = [this.translate.instant('g.time'), this.translate.instant('perf_analytic.value_mins')];

		let headerObj = {};
		columnNames.forEach((column, colIdx) => {
			let colId = alphabits[colIdx];
			headerObj[colId] = column;
		});
		let header = [headerObj];

		let fileName = this.commonService.getCleanFileName(this.currentSite.name) +
						' - ' + this.device.config_info.truck_id +
						' - ' + this.deviceService.translate('site_performance.idle_events_report', this.device.config_info);
		let colLength = Object.keys(headerObj).length;
		['avg', 'total'].forEach((type)=>{
			let typeObj = header.slice();
			this.idleChartData[type].forEach((column) => {
				let vals = {};
				column.forEach((col, idx) => {
					if(idx >= colLength)
						return;
					let colId = alphabits[idx];
					vals[colId] = idx == 1 ? (decimalPipe.transform(col, '1.2-2') ?? '-') : col;
				});
				typeObj.push(vals);
			});
			let file = fileName + ' - ' + this.translate.instant('device_performance.'+type);
			new AngularCsv(typeObj, file);
		});
	}

	exportEndVoltage() {
		const csvFileHeaderInfo = this.commonService.getCsvFileHeadersInfo({
			customerName: this.currentSite.customer_name,
			siteName: this.currentSite.name,
			deviceSN: this.device.serial_number
		});

		let alphabits = this.commonService.alphabetCharacters;
		let columnNames = [
			this.translate.instant('events.sequence_id'),
			this.translate.instant('events.timestamp'),
			this.translate.instant('event.vpc')
		];

		let headerObj = {};
		columnNames.forEach((column, colIdx) => {
			let colId = alphabits[colIdx];
			headerObj[colId] = column;
		});

		const dataObj = [
			...csvFileHeaderInfo,
			headerObj
		];

		let tableItems = this.endVoltageAllTableItems;
		let chartName = this.deviceService.translate('site_performance.end_voltage_report', this.device.config_info);

		if (this.deviceConfig.dailyDetails.hasTypes.chargerEndVoltage)
			chartName = this.deviceService.translate('site_performance.end_voltage_report', this.device.config_info);

		let fileName = this.commonService.getCleanFileName(this.currentSite.name) +
						' - ' + this.device.config_info.truck_id +
						' - ' + chartName;
		let colLength = Object.keys(headerObj).length;

		let chartData = [];
		let chartItems = tableItems.slice();
		for(let dayItems of chartItems) {
			if(dayItems) {
				for(let item of dayItems) {
					chartData.push([item.sequence_id, item.timestamp, item.vpc]);
				}
			}
		}
		chartData = _.sortBy(chartData, 2).reverse();

		chartData.forEach((column) => {
			let vals = {};
			column.forEach((col, idx) => {
				if(idx >= colLength)
					return;
				let colId = alphabits[idx];
				vals[colId] = col;
			});
			dataObj.push(vals);
		});
		new AngularCsv(dataObj, fileName);
	}

	exportChargeEndVoltage() {
		const csvFileHeaderInfo = this.commonService.getCsvFileHeadersInfo({
			customerName: this.currentSite.customer_name,
			siteName: this.currentSite.name,
			deviceSN: this.device.serial_number
		});

		let alphabits = this.commonService.alphabetCharacters;
		let columnNames = [
			this.translate.instant('events.sequence_id'),
			this.translate.instant('events.timestamp'),
			this.translate.instant('event.vpc')
		];

		let headerObj = {};
		columnNames.forEach((column, colIdx) => {
			let colId = alphabits[colIdx];
			headerObj[colId] = column;
		});

		const dataObj = [
			...csvFileHeaderInfo,
			headerObj
		];

		let fileName = this.commonService.getCleanFileName(this.currentSite.name) +
						' - ' + this.device.config_info.truck_id +
						' - ' + this.deviceService.translate('site_performance.charge_end_voltage_report', this.device.config_info);
		let colLength = Object.keys(headerObj).length;

		let chartData = [];
		let chartItems = this.chargeEndVoltageAllTableItems.slice();
		for(let dayItems of chartItems) {
			if(dayItems) {
				for(let item of dayItems) {
					chartData.push([item.sequence_id, item.timestamp, item.vpc]);
				}
			}
		}
		chartData = _.sortBy(chartData, 2).reverse();

		chartData.forEach((column) => {
			let vals = {};
			column.forEach((col, idx) => {
				if(idx >= colLength)
					return;
				let colId = alphabits[idx];
				vals[colId] = col;
			});
			dataObj.push(vals);
		});
		new AngularCsv(dataObj, fileName);
	}

	exportTruckHours() {
		let alphabits = this.commonService.alphabetCharacters;
		let columnNames = [this.translate.instant('g.date'), this.translate.instant('site_performance.time_report_title')];

		let headerObj = {};
		columnNames.forEach((column, colIdx) => {
			let colId = alphabits[colIdx];
			headerObj[colId] = column;
		});
		let header = [headerObj];

		let fileName = this.commonService.getCleanFileName(this.currentSite.name) +
						' - ' + this.device.config_info.truck_id +
						' - ' + this.deviceService.translate('device_performance.daily_truck_hours', this.device.config_info);
		let colLength = Object.keys(headerObj).length;
		let dataObj = header.slice();

		let chartData = this.truckHoursChartData.slice();
		// chartData = _.sortBy(chartData, 1).reverse();

		chartData.forEach((column) => {
			let vals = {};
			column.forEach((col, idx) => {
				if(idx >= colLength)
					return;
				let colId = alphabits[idx];
				vals[colId] = col;
			});
			dataObj.push(vals);
		});
		new AngularCsv(dataObj, fileName);
	}

	chartReadyFunct($event) {
		this.chartsReady[$event[0]] = $event[1];
	}

	onSelectionChanged(element) {
		this.chRef.markForCheck();
	}


	exportTotalUsage() {
		const translationPath = this.deviceConfig.translationPath;

		this.commonService.exportTotalUsageWidget(
			{
				siteName: this.currentSite.name,
				startDate: this.usageFromDate,
				endDate: this.usageToDate,
				usageAmpData: this.usageChartDataAmp,
				usageWattData: this.usageChartDataWatt
			}, translationPath);
	}

	exportRtData() {
		const csvFileHeaderInfo = this.commonService.getCsvFileHeadersInfo({
			customerName: this.currentSite.customer_name,
			siteName: this.currentSite.name,
			deviceSN: this.device.serial_number
		});

		const columns = [this.translate.instant('g.time')];

		if (this.visibilityCheckboxes.voltage)
			columns.push(this.translate.instant('rt.voltage'));

		if (this.visibilityCheckboxes.current)
			columns.push(this.translate.instant('rt.current'));

		const data = [];

		for(const rtData of this.rtChartObject.data || []) {
			const formattedData:any = [];
			formattedData.push(moment(rtData[0]).format('MM/DD/YYYY HH:mm:ss'));

			if (this.visibilityCheckboxes.voltage)
				formattedData.push(rtData[1]);

			if (this.visibilityCheckboxes.current)
				formattedData.push(rtData[2]);

			data.push(formattedData);
		}

		const dataObj = [...csvFileHeaderInfo, columns, ...data];
		const fileName = this.translate.instant('device_performance.battery_realtime_charts');

		new AngularCsv(dataObj, fileName);
	}

	handleStudyDeviceStartEndDate() {
		this.studyStartTime = new Date(this.studyInfo.start_study_time*1000);
		this.studyEndTime = this.studyInfo.is_done? new Date(this.studyInfo.end_study_time*1000) : new Date();

		this.deviceInstallationDate = this.studyStartTime;
		this.maxDate = this.studyInfo.is_done ? this.studyEndTime : new Date();
		const maxDate = this.studyInfo.is_done ? this.studyEndTime : new Date(new Date().setDate(new Date().getDate() - 1));

		this.idleTimesFromDate = this.studyStartTime
		this.idleTimesToDate = maxDate;

		this.endVoltageFromDate = this.studyStartTime
		this.endVoltageToDate = maxDate;

		this.usageFromDate = this.studyStartTime
		this.usageToDate = maxDate;

		this.truckHoursFromDate = this.studyStartTime
		this.truckHoursToDate = maxDate;

		this.usageChartDataAmp = [];
		this.usageChartDataWatt = [];
		this.getUtilizationScoreData();
		this.getDailyDetails('idleTimes');
		this.getDailyDetails('endVoltage');
		this.getDailyDetails('usage');
		this.getDailyDetails('truckHours');
	}

	drawRTrecordsChart() {
		this.showRtChart = false;
		if (Object.keys(this.rtChartData).length === 0)
			return;

		let vAxes = {
			"0" : {
				"textPosition": "out",
					textStyle: {color: '#328332'},
					title: "Battery Voltage (V)",
					titleTextStyle: {color: '#328332'},
				},
			"1" : {
				"textPosition": "in",
				textStyle:{color: '#2828ab'},
				title: "Battery Current (A)",
				titleTextStyle: {color: '#2828ab'}
			},
		};
		let series: any = {
			"0" : {
				"targetAxisIndex":0,
				"color": "#328332" ,
				type: 'line'
			},
			"1" : {
				"targetAxisIndex":1,
				"color" : "#2828ab",
				type: 'line'
			},
		};

		let config = {
			... this.rtChartDefaultConfig,
			vAxes: vAxes,
			series: series,
		};

		if (!this.visibilityCheckboxes.voltage) {
			config.series["0"].lineWidth = 0;
			config.series["0"].enableInteractivity= false;
			config.series["0"].tooltip ="none";
			config.vAxes["0"].textPosition = "none";
			config.vAxes["0"].title = "";
		}
		if (!this.visibilityCheckboxes.current) {
			config.series["1"].lineWidth = 0;
			config.series["1"].enableInteractivity= false;
			config.series["1"].tooltip ="none";
			config.vAxes["1"].textPosition = "none";
			config.vAxes["1"].title = "";
		}

		this.rtChartObject.columnNames = ['Date', 'Voltage', 'Current'];
		let data = [];
		this.rtChartObject.data = [];
		const deviceCells = this.device.config_info.number_of_cells || 1;

		for (let time in this.rtChartData) {
			const rawVolt = this.rtChartData[time].volt || 0;
			const voltToShow = this.selectedBatteryRealTimeVoltageShow == 'voltage_per_cell' ? Math.round((rawVolt / deviceCells)*100)/100 : Math.round(rawVolt);

			const rtData = [
				new Date(new Date(+time*1000).getTime() - (new Date().getTimezoneOffset() * -1 * 60 * 1000)),
				voltToShow,
				Math.round(this.rtChartData[time].amp || 0),
			];
			data.push(rtData);
		};

		let rtSorter =  function(a, b) {
			if (a[0] < b[0]) return -1;
			if (a[0] > b[0]) return 1;
			return 0;
		}

		this.rtChartObject.data = data.sort(rtSorter);
		this.rtChartObject.config = config;

		if (data.length > 1)
			this.showRtChart = true;
	}

	drawTempChart() {
		this.showTempChart = false;
		if (Object.keys(this.rtChartData).length === 0) return;

		const maxTempLimit = Number(this.highTemperatureLimit || 130);
		const tempUnitSymbol = this.commonService.tempUnitSymbol(this.temperatureUnit);

		let config = {
			...this.rtChartDefaultConfig,
			legend: { position: 'top', alignment: 'right' }, 
			title: this.translate.instant('exception_reports.battery_temperature'),
			vAxis: { title: `${this.translate.instant('exception_reports.battery_temperature')} (${tempUnitSymbol})`, titleTextStyle: { color: '#FFA500' } },
			series: {
				0: { color: '#FFA500', type: 'line'},
				1: { color: '#FF0000', type: 'line', lineDashStyle: [4, 4], lineWidth: 2 }
			}
		};

		this.tempChartObject.columnNames = ['Date', `Temperature (${tempUnitSymbol})`, `Max Temperature Limit (${tempUnitSymbol})`];
		let data = [];

		for (let time in this.rtChartData) {
			data.push([
				new Date(new Date(+time * 1000).getTime() - (new Date().getTimezoneOffset() * -1 * 60 * 1000)),
				Math.round(this.rtChartData[time].temp || 0),
				maxTempLimit
			]);
		}

		this.tempChartObject.data = data.sort((a, b) => a[0] - b[0]);
		this.tempChartObject.config = config;

		if (data.length > 1) {
			this.showTempChart = true;
		}
	}

	drawSocChart() {
		this.showSocChart = false;
		if (!this.rtChartData || Object.keys(this.rtChartData).length === 0) return;

		let minSocLimit = 1000000;
		for (let time in this.rtChartData) {
			const soc = Math.round(this.rtChartData[time].soc);
			if (soc < minSocLimit)
				minSocLimit = soc;
		}

		const columnNames: string[] = ['Date', 'SOC', 'Minimum Battery SOC'];
		const series: any = {
			0: { color: '#28a745', lineWidth: 2 },
			1: {
				color: '#FFA500',
				lineWidth: 2,
				lineDashStyle: [4, 4],
				visibleInLegend: true,
			},
		};

		let seriesIndex = 2;

		if (this.show20PercentLine) {
			columnNames.push('20% Threshold');
			series[seriesIndex++] = {
				visibleInLegend: false,
				color: '#FF0000',
				lineDashStyle: [6, 4],
				enableInteractivity: false,
			};
		}

		if (this.show80PercentLine) {
			columnNames.push('80% Threshold');
			series[seriesIndex++] = {
				visibleInLegend: false,
				color: '#00AA00',
				lineDashStyle: [6, 4],
				enableInteractivity: false,
			};
		}

		let data = [];
		for (let time in this.rtChartData) {
			const row: any[] = [
				new Date(new Date(+time * 1000).getTime() - (new Date().getTimezoneOffset() * -1 * 60 * 1000)),
				Math.round(this.rtChartData[time].soc),
				minSocLimit,
			];

			if (this.show20PercentLine)
				row.push(this.percentValueOf20);
			if (this.show80PercentLine)
				row.push(this.percentValueOf80);

			data.push(row);
		}

		this.socChartObject.columnNames = columnNames;
		this.socChartObject.data = data.sort((a, b) => a[0] - b[0]);
		this.socChartObject.config = {
			...this.rtChartDefaultConfig,
			title: 'Battery % SOC',
			legend: { position: 'top', alignment: 'right' },
			vAxis: { title: 'Percentage (%)', titleTextStyle: { color: '#28a745' } },
			series: series,
		};

		if (data.length > 1)
			this.showSocChart = true;
	}

	exportRtChartData(chartData: any[] | undefined, valueColumnKey: string) {
		const csvFileHeaderInfo = this.commonService.getCsvFileHeadersInfo({
			customerName: this.currentSite.customer_name,
			siteName: this.currentSite.name,
			deviceSN: this.device.serial_number
		});

		const columns = [
			this.translate.instant('g.time'),
			this.translate.instant(valueColumnKey)
		];

		const data = (chartData || []).map(item => ([
			moment(item[0]).format('MM/DD/YYYY HH:mm:ss'),
			item[1]
		]));

		const dataObj = [...csvFileHeaderInfo, columns, ...data];
		const fileName = this.translate.instant('device_performance.battery_realtime_charts');

		new AngularCsv(dataObj, fileName);
	}
	getFilters(filters: any) {
		this.selectedDays = filters.selectedDays;
		this.selectedPeriod = filters.selectedPeriod;
	}

	isBattlinkDeviceType(type: number) {
		return DeviceFactory.isBattlinkDeviceType(type);
	}
}
